import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Building2 } from "lucide-react";
import { api } from "../lib/api";
import { DepartmentRowsSkeleton } from "../components/PageSkeletons";

export default function DepartmentEmployees() {
  const { id } = useParams();
  const [department, setDepartment] = useState(null);
  const [employees, setEmployees] = useState(null);

  useEffect(() => {
    api.get("/departments").then(({ data }) => setDepartment(data.find((d) => d.id === id) ?? null)).catch(() => setDepartment(null));
  }, [id]);

  useEffect(() => {
    if (!department) return;
    api.get("/employees?status=all").then(({ data }) => setEmployees(data.filter((e) => e.department === department.name))).catch(() => setEmployees([]));
  }, [department]);

  return (
    <div className="space-y-8 fade-up max-w-2xl">
      <div>
        <Link to="/console/departments" className="inline-flex items-center gap-1.5 text-sm text-neutral-500 hover:text-[#111] transition-colors">
          <ArrowLeft className="w-4 h-4" /> Departments
        </Link>
        <div className="flex items-center gap-3 mt-3">
          <div className="w-9 h-9 rounded-md bg-neutral-100 border border-neutral-200 flex items-center justify-center">
            <Building2 className="w-4 h-4 text-neutral-600" />
          </div>
          <h1 className="font-heading font-light text-3xl tracking-tight" data-testid="department-employees-title">
            {department?.name ?? "Department"}
          </h1>
        </div>
      </div>

      <div className="bg-white border border-neutral-200 rounded-lg overflow-hidden">
        {employees === null ? (
          <DepartmentRowsSkeleton />
        ) : employees.length === 0 ? (
          <p className="px-6 py-8 text-center text-sm text-neutral-400">No employees in this department.</p>
        ) : (
          <>
            <div className="px-6 py-3 flex items-center justify-between bg-neutral-50 border-b border-neutral-100 text-xs font-medium text-neutral-500 uppercase tracking-wide">
              <span>Employee</span>
              <div className="flex items-center gap-4 shrink-0">
                <span className="w-24 text-right">App ID</span>
                <span className="w-32 text-right">Serial number</span>
              </div>
            </div>
            <div className="divide-y divide-neutral-100">
              {employees.map((emp) => (
                <div key={emp.id} data-testid={`department-employee-${emp.id}`} className="px-6 py-3.5 flex items-center justify-between gap-3">
                  <Link to={`/console/employees/${emp.id}`} className="text-sm font-medium hover:underline underline-offset-4 inline-flex items-center gap-1 min-w-0 truncate">
                    {emp.name} <ArrowUpRight className="w-3 h-3 text-neutral-400 shrink-0" />
                  </Link>
                  <div className="flex items-center gap-4 shrink-0 text-xs font-mono-data text-neutral-500">
                    <span className="w-24 text-right truncate" title="App ID">{emp.device?.app_id ?? "—"}</span>
                    <span className="w-32 text-right truncate" title="Serial number">{emp.device?.serial_number ?? "—"}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
